angular.module('app.components')
  .directive('dotsBar', () => ({
    restrict: 'E',
    replace: true,
    scope: {
      config: '=',
    },
    template: `
      <div class="tp-dot-graph-wrap">
        <i ng-if="config.dots.length > 52"
          class="icon-font icon-tracking-points"></i>
        <ul ng-if="config.dots.length <= 52"
          class="tp-dot-graph tp-dot-graph--md tp-dot-graph--{{config.total}}">
          <li ng-repeat="$index in config.dots"
            ng-class="{'danger' : $index < config.value}">
          </li>
        </ul>
      </div>`,
  }));
